import GlobalVendasLogo from "../assets/media/logo-global-vendas.png";
import Box13GarageLogo from "../assets/media/box13-garage-logo-black.png";
import JrFigurinhasLogo from "../assets/media/logo-jr.jpeg";

const WHATSAPP_NUMBER = "554191150056";

function waLink(message) {
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

// As seis situações de diagnóstico. As quatro primeiras aparecem no seletor
// da home; todas têm página própria em /diagnostico/:slug (qa em /servicos/qa-e-testes).
const DIAGNOSTICO = [
    {
        id: "manual",
        slug: "processo-manual",
        icon: "sync_problem",
        label: "Processo manual demais",
        hint: "Planilha, copiar e colar, retrabalho",
        tag: "Automação de processos",
        route: "/diagnostico/processo-manual",
        common: true,
        title: "Se a equipe repete a mesma tarefa todo dia, isso pode virar rotina automática",
        body: "Mapeamos o processo do jeito que ele acontece hoje, cortamos o que não precisa existir e automatizamos o resto — integrações, disparos e conferências que passam a rodar sozinhas, sem ninguém precisar lembrar.",
        sinais: [
            "Alguém do time passa horas copiando dados de um lugar para outro",
            "A planilha é a fonte da verdade, e existem três versões dela",
            "Cobranças, avisos e conferências dependem de alguém lembrar"
        ],
        steps: [
            "Mapa do processo atual, com onde o tempo se perde",
            "Automação das rotinas repetitivas e dos avisos",
            "Painel simples para o gestor acompanhar sem planilha"
        ],
        entregas: [
            "Desenho do processo antes e depois, por escrito",
            "Rotinas automáticas rodando em produção",
            "Painel de acompanhamento para o gestor",
            "Treinamento do time e suporte no mesmo canal"
        ],
        placeholder: "Ex.: a equipe passa a tarde copiando pedidos do WhatsApp para uma planilha",
        cta: "Pedir diagnóstico deste caso",
        fechamento: "Conte a rotina que mais consome tempo hoje",
        client: "Global Vendas",
        logo: GlobalVendasLogo,
        metric: "−4 h/semana",
        metricLabel: "de tarefas manuais de cobrança",
        quote: "Paramos de perder tempo com cobranças.",
        initials: "GV",
        author: "Sócio-diretor · Global Vendas",
        faq: [
            { q: "Preciso trocar os sistemas que já uso?", a: "Na maioria dos casos, não. A automação conversa com o que já existe — planilha, ERP, WhatsApp, e-mail — e só trocamos alguma peça se ela for o próprio gargalo." },
            { q: "O time vai precisar aprender algo complicado?", a: "O objetivo é o contrário: o time faz menos passos do que hoje. O treinamento costuma levar uma reunião." },
            { q: "E se o processo mudar depois?", a: "Automação de processo real muda junto. Ajustes pequenos entram no suporte; mudanças grandes são orçadas antes, nunca cobradas por surpresa." }
        ]
    },
    {
        id: "sistema",
        slug: "sistema-sob-medida",
        icon: "grid_view",
        label: "Falta um sistema próprio",
        hint: "Nada no mercado serve à operação",
        tag: "Software sob medida",
        route: "/diagnostico/sistema-sob-medida",
        title: "Quando nenhum sistema de prateleira cabe na sua operação, a gente constrói o seu",
        body: "Software desenhado em cima do fluxo real do seu time — sem campos que ninguém usa e sem torcer o processo para caber na ferramenta. Escopo e entregas fechados por escrito antes de a primeira linha ser escrita.",
        sinais: [
            "Você já testou dois ou três sistemas e nenhum encaixou",
            "O controle importante vive numa planilha que só uma pessoa entende",
            "Cada cliente ou obra tem uma exceção que o sistema pronto não aceita"
        ],
        steps: [
            "Escopo fechado por escrito, aprovado por você",
            "Primeira versão utilizável antes do projeto todo",
            "Evolução contínua conforme o time usa"
        ],
        entregas: [
            "Documento de escopo aprovado por escrito",
            "Sistema no ar, com seus dados migrados",
            "Acesso por perfil e histórico de alterações",
            "Suporte e evolução combinados em contrato"
        ],
        placeholder: "Ex.: controlo obras em três planilhas e ninguém sabe qual é a versão certa",
        cta: "Pedir diagnóstico deste caso",
        fechamento: "Descreva a operação que nenhum sistema atendeu",
        client: "Box13 Garage",
        logo: Box13GarageLogo,
        metric: "orçamento em 5 min",
        metricLabel: "no lugar de 40 minutos por proposta",
        quote: "Fecho orçamento com o cliente ainda no balcão.",
        initials: "B13",
        author: "Proprietário · Box13 Garage",
        faq: [
            { q: "Quanto tempo até eu ver algo funcionando?", a: "A primeira versão utilizável sai bem antes do fim do projeto. Você usa, aponta o que está errado, e a gente corrige antes de seguir." },
            { q: "O sistema fica meu?", a: "Sim. Código, dados e acessos são seus, com contrato dizendo isso. Você não fica preso à Mango para continuar operando." },
            { q: "E se o escopo crescer no meio?", a: "Crescer é normal. O que não é normal é a conta crescer sem aviso: mudança de escopo vira um adendo escrito, aprovado por você, antes de ser executada." }
        ]
    },
    {
        id: "site",
        slug: "site-que-nao-converte",
        icon: "language",
        label: "Site que não traz cliente",
        hint: "Visita entra e não vira contato",
        tag: "Sites e landing pages",
        route: "/diagnostico/site-que-nao-converte",
        title: "Um site que explica o que você vende e facilita o primeiro contato",
        body: "Página construída em torno de uma decisão só: entender a oferta e falar com você. Estrutura preparada para busca orgânica e para campanhas, com medição de onde cada contato veio.",
        sinais: [
            "Chega visita, mas ninguém chama no WhatsApp nem preenche nada",
            "Você não sabe dizer quantos contatos o site trouxe no mês passado",
            "Quem entra pergunta coisas que o site deveria ter respondido"
        ],
        steps: [
            "Mensagem e estrutura definidas antes do visual",
            "Página rápida, indexável e pronta para anúncio",
            "Contato por WhatsApp, telefone e formulário curto"
        ],
        entregas: [
            "Texto e estrutura aprovados antes do desenho",
            "Página rápida em celular, com nota de desempenho",
            "Medição de origem de cada contato",
            "Formulário curto ligado ao seu e-mail ou CRM"
        ],
        placeholder: "Ex.: tenho um site antigo, mas quem entra não me chama no WhatsApp",
        cta: "Pedir diagnóstico deste caso",
        fechamento: "Conte o que o seu site deveria estar trazendo",
        client: "Junior Figurinhas",
        logo: JrFigurinhasLogo,
        metric: "+3× contatos",
        metricLabel: "no primeiro trimestre após a nova página",
        quote: "O pessoal chega sabendo o que a gente faz.",
        initials: "JR",
        author: "Proprietário · Junior Figurinhas",
        faq: [
            { q: "Só o site resolve, ou preciso de anúncio?", a: "Uma página boa melhora qualquer origem de tráfego, mas não cria tráfego sozinha. Dizemos com clareza se o seu caso precisa de anúncio, conteúdo ou só de arrumar a página." },
            { q: "Vocês escrevem os textos?", a: "Sim, com você. A entrevista inicial existe para o texto sair na sua voz, não na nossa — e você aprova antes de virar layout." },
            { q: "Consigo editar depois?", a: "Sim. Entregamos com painel de edição para os trechos que mudam, e o que precisa de código entra no suporte." }
        ]
    },
    {
        id: "ti",
        slug: "ti-desorganizada",
        icon: "tips_and_updates",
        label: "TI desorganizada",
        hint: "Assinaturas, ferramentas e custos sem controle",
        tag: "Consultoria de TI",
        route: "/diagnostico/ti-desorganizada",
        noCase: true,
        title: "Antes de comprar mais licença, vale organizar o que já existe",
        body: "Diagnóstico do que a empresa usa hoje, do que dá para consolidar e do que pode ser substituído por solução open source implantada e mantida pela Mango — com custo previsível e sem armadilha de renovação.",
        sinais: [
            "Aparecem assinaturas no cartão que ninguém sabe explicar",
            "Duas ferramentas fazem a mesma coisa em setores diferentes",
            "Quando alguém sai da empresa, ninguém sabe quais acessos revogar"
        ],
        steps: [
            "Inventário de ferramentas, custos e sobreposições",
            "Plano de consolidação com prioridade e economia estimada",
            "Implantação e manutenção das ferramentas escolhidas"
        ],
        entregas: [
            "Inventário com custo mensal por ferramenta",
            "Plano de consolidação priorizado",
            "Estimativa de economia por decisão",
            "Implantação e manutenção do que ficar"
        ],
        placeholder: "Ex.: pago cinco assinaturas e não sei quem usa cada uma",
        cta: "Pedir diagnóstico deste caso",
        fechamento: "Conte quantas ferramentas você paga hoje",
        faq: [
            { q: "Vocês vão me obrigar a trocar tudo por open source?", a: "Não. Open source entra quando reduz custo sem perder função. Se a ferramenta paga vale o preço, a recomendação é manter." },
            { q: "O diagnóstico serve se eu não contratar mais nada?", a: "Serve, e é entregue por escrito. Você pode executar o plano com quem quiser, inclusive com o seu time." },
            { q: "Quem cuida depois da implantação?", a: "A Mango, se você quiser: manutenção, atualização e suporte no mesmo canal, com valor mensal fechado." }
        ]
    },
    {
        id: "outro",
        slug: "conversa-aberta",
        icon: "help",
        label: "Outro / não sei classificar",
        hint: "Descreva do seu jeito, a gente nomeia",
        tag: "Conversa aberta",
        route: "/diagnostico/conversa-aberta",
        noCase: true,
        semCategoria: true,
        title: "Não precisa saber o nome do problema para pedir ajuda",
        body: "Se a sua situação não é nenhuma das quatro, ou é um pouco de cada, descreva do seu jeito. A primeira conversa serve exatamente para nomear o gargalo e dizer se vale construir software agora ou arrumar o processo antes.",
        sinais: [
            "Você sabe que algo trava, mas não sabe dar nome",
            "Parece um pouco de cada problema, e nenhum se encaixa direito",
            "Já ouviu propostas técnicas que não explicaram o que resolveriam"
        ],
        steps: [
            "Você descreve a rotina em duas ou três frases",
            "Conversa de 20 minutos para entender o contexto",
            "Resposta honesta: o que fazer primeiro, mesmo que não seja com a Mango"
        ],
        entregas: [
            "Um nome claro para o problema que você descreveu",
            "Ordem do que resolver primeiro e por quê",
            "Recomendação honesta, inclusive a de não contratar agora"
        ],
        placeholder: "Ex.: temos três sistemas que não conversam e ninguém sabe onde está o dado certo",
        cta: "Descrever meu caso",
        fechamento: "Descreva a rotina do seu jeito, sem termo técnico",
        faq: [
            { q: "E se o meu problema não for de software?", a: "A gente diz. Já aconteceu de a resposta ser mudar um combinado interno em vez de contratar sistema — e é isso que você vai ouvir, mesmo sem virar projeto." },
            { q: "A conversa custa algo?", a: "Não. A primeira conversa é sem custo e sem compromisso, e serve para os dois lados decidirem se faz sentido seguir." },
            { q: "Preciso preparar alguma coisa?", a: "Só saber contar como o dia funciona hoje. Se tiver print da planilha ou do sistema, ajuda; se não tiver, a conversa resolve." }
        ]
    },
    {
        id: "qa",
        slug: "qa-e-testes",
        icon: "fact_check",
        label: "QA e testes",
        hint: "Cada atualização quebra algo que já funcionava",
        tag: "QA e testes",
        route: "/servicos/qa-e-testes",
        noCase: true,
        exemploSemCliente: [
            "Um sistema de operação com quatro fluxos que não podem falhar: entrada de pedido, cobrança, emissão e baixa.",
            "Roteiro de teste escrito para os quatro, mais testes automáticos nos dois que envolvem dinheiro.",
            "Combinado de o que precisa passar antes de qualquer versão subir — quem aprova e o que trava a publicação."
        ],
        title: "Lançar uma versão nova sem quebrar o que já funcionava",
        body: "Quando o sistema cresce, cada ajuste vira risco: mexe num lugar, estraga outro. QA é o trabalho de descobrir isso antes do seu cliente descobrir — com roteiro de teste, testes automáticos nos pontos críticos e um combinado de o que precisa passar antes de subir.",
        sinais: [
            "Toda entrega nova traz de volta um problema antigo",
            "Ninguém consegue dizer com segurança se dá para subir hoje",
            "O erro aparece primeiro pela reclamação do cliente"
        ],
        steps: [
            "Levantamento dos fluxos que não podem falhar de jeito nenhum",
            "Roteiro de teste manual e testes automáticos nos pontos críticos",
            "Rotina de verificação antes de cada publicação"
        ],
        entregas: [
            "Lista dos fluxos críticos, acordada com o seu time",
            "Testes automáticos rodando a cada alteração",
            "Roteiro de verificação antes de publicar",
            "Relatório do que passou e do que ficou pendente"
        ],
        placeholder: "Ex.: cada atualização quebra alguma coisa que já funcionava",
        cta: "Pedir diagnóstico deste caso",
        fechamento: "Conte o que costuma quebrar quando vocês publicam",
        faq: [
            { q: "Serve para sistema que não foi feito pela Mango?", a: "Serve, e é o caso mais comum. Começamos entendendo o que existe e onde dói, sem exigir reescrever nada." },
            { q: "Testar não deixa tudo mais lento?", a: "No começo, um pouco. Depois é o contrário: o time para de gastar tempo apagando incêndio de coisa que já funcionava." },
            { q: "Preciso de QA contínuo ou é pontual?", a: "Depende do ritmo de mudança. Se você publica raramente, uma rodada resolve; se publica toda semana, compensa deixar a verificação automática rodando." }
        ]
    }
];

// As seis frentes exibidas na grade de serviços (home e rodapé).
const FRENTES = [
    { icon: "sync_problem", title: "Automação de processos", short: "Rotinas manuais que passam a rodar sozinhas", route: "/diagnostico/processo-manual" },
    { icon: "grid_view", title: "Software sob medida", short: "Sistema desenhado no fluxo do seu time", route: "/diagnostico/sistema-sob-medida" },
    { icon: "language", title: "Sites e landing pages", short: "Página que explica a oferta e gera contato", route: "/diagnostico/site-que-nao-converte" },
    { icon: "tips_and_updates", title: "Consultoria de TI", short: "Ferramentas, custos e prioridades organizados", route: "/diagnostico/ti-desorganizada" },
    { icon: "source", title: "Open source implantado", short: "Instalação, configuração e manutenção", route: "/diagnostico/ti-desorganizada" },
    { icon: "fact_check", title: "QA e testes", short: "Lançar e evoluir sem quebrar o que funciona", route: "/servicos/qa-e-testes" }
];

const FAQ_GERAL = [
    { q: "Quanto custa um projeto?", a: "Ninguém chuta por telefone. Na primeira conversa fazemos a análise dos requisitos; o time estima o esforço de desenvolvimento e só então precifica, por escrito. Se o valor não couber no seu momento, enxugamos o escopo até o que resolve o problema principal — o resto fica para depois." },
    { q: "Vocês atendem quem está longe?", a: "Sim. Atendemos empresas em todo o Brasil e em Portugal, com reuniões de hora marcada e um canal direto com quem está construindo. Não há custo de deslocamento no orçamento." },
    { q: "Em quanto tempo fica pronto?", a: "O cronograma sai da mesma estimativa de esforço e vem por escrito junto com a proposta. Você usa a primeira versão antes de tudo estar concluído." },
    { q: "E se eu não souber o que preciso?", a: "É o caso mais comum. Escolha a opção “Outro / não sei classificar” e descreva a rotina do seu jeito: nomear o problema é a nossa parte." },
    { q: "O que acontece depois que eu envio?", a: "Uma pessoa do time lê o que você escreveu e responde em até 1 dia útil pelo telefone informado, com o caminho sugerido para o seu caso." },
    { q: "Vocês dão suporte depois de entregar?", a: "Sim, no mesmo canal do projeto. Correções, ajustes e evolução conforme o time usa — combinados antes, não cobrados por surpresa." }
];

const TRUST = [
    { value: "Brasil e Portugal", label: "área de atendimento", note: "Sem custo de deslocamento no orçamento" },
    { value: "+ de 3 anos", label: "de operação", note: "Time próprio, sem interrupção" },
    { value: "+ de 100", label: "projetos entregues", note: "Sistemas, automações e sites" },
    { value: "1 dia útil", label: "para responder", note: "Compromisso de retorno" }
];

const CLIENTES = ["Global Vendas", "Junior Figurinhas", "Box13 Garage", "Jonatã Canela"];

function findDiagnostico(slug) {
    return DIAGNOSTICO.find((item) => item.slug === slug);
}

function diagnosticoWaLink(item) {
    return waLink(`Olá! Vim pelo site. Minha situação: ${item.label}.`);
}

export {
    WHATSAPP_NUMBER,
    waLink,
    DIAGNOSTICO,
    FRENTES,
    FAQ_GERAL,
    TRUST,
    CLIENTES,
    findDiagnostico,
    diagnosticoWaLink
};
export default DIAGNOSTICO;
